<template>
  <div :class="checked && 'cb-checked'">
    <div class="cb-container" @click="toggleCheckbox">
      <label class="cbi">
        <input
          type="checkbox"
          :value="value"
          :checked="value"
          @change="$emit('input', $event.target.checked)"
          @click="toggleCheckbox"
          :id="`${title}-input-id`"
        >
        <span class="cb-check" />
      </label>
      <p class="cb-title">
        {{ title }}
      </p>
    </div>

    <div class="cb-content">
      <slot />
    </div>
  </div>
</template>

<script>
export default {
  name: 'Checkbox',
  props: {
    title: {
      type: String,
    },
    description: {
      type: String,
    },
    value: {
      type: Boolean,
    },
    checked: {
      type: Boolean,
      required: false,
    },
  },
  methods: {
    toggleCheckbox() {
      this.$emit('input', !this.value);
    },
  },
};
</script>
